<script>
    import { onMount } from 'svelte'
    import { fly, fade } from 'svelte/transition'
    import { db } from './firebase'
    import Header from './Header.svelte'
    export let params = {}
    import { push } from 'svelte-spa-router'


    let formTitle = 'View Form Results'
    let formData = []
    let responses = []
	let loading = true
    let orderedRespondees = ['8hZcyxE5rSNZhKEulCvCNDRb7hA2','ElunubMyWpafoEmG4ThWuiFzQWn1','K41Dv7UlTRRm6f3FxTzaedyGH1E3','QpeGe17zAxOzqxcErYnGyxagkIL2','VM8sDMPWtrgScrk3xSSUtyFBop32','ZGt9OAbgbTVONLPPYJ44QDPUO872','o6TASdFPPFhhrCiHno8Dpecv2tI3','ohG9QVaRlyaK5uIEHpcTvCv6xwg1','xzxWNekOjrewZ8Nu0LuIeexsFvA3']
    // let viewMode = 'in-order'
    // 'ofg1zMkYOnePyCAjdr2JYx6nh213'
    let currentQuestion = 0
    let slideBuildStage = 0
    let listBuildStage = 0
    let lastPieChartDecimal = 0
    let lastPieChartQuestion = 0
    let titleScreen = false //TEMP
    // let totalResponses = responses.length

    onMount(() => {
		getFormData()
	})

    const getFormData = () => {
		db.collection('forms').doc(params.form).get().then((doc) => {
			if (doc.exists) {
				formData = doc.data()
                db.collection('responses').where('form', '==', params.form).get().then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        responses = [...responses, doc.data()]
                    })
                    loading = false
                })
			} else {
				console.log("No such document!")
			}
		}).catch((error) => {
			console.log(error);
		})
	}
    const countedResponse = (response, question) => {
        // console.log(response)
        // console.log(question)
        let responses = []
        response.forEach(response => {
            // console.log(response.responses)
            responses = [...responses, response.responses[question]]
        })
        // console.log(responses)

        let counted = responses.reduce((countsMap, item) => countsMap.set(item, countsMap.get(item) + 1 || 1), new Map())
        // console.log(counted)
        return ''
    }
    const shuffleArray = (array, question) => {
        // Create an array of just responses for current question, then sort randomlu
        let questionResponses = []
        array.forEach((response) => {
            questionResponses = [...questionResponses, response.responses[question]]
        })
        return questionResponses.sort(() => Math.random() - 0.5)
    }
    // const sortArray = (array, question) => {
    //     // Create an array of just responses for current question, then sort alphabetically
    //     let questionResponses = []
    //     array.forEach((response) => {
    //         questionResponses = [...questionResponses, response.responses[question]]
    //     })
    //     questionResponses = questionResponses.sort()

    //     // // console.log(questionResponses.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {}))
    //     // let countedQuestionResponses = []

    //     // questionResponses.forEach((response, index) => {
    //     //     let currentAnswerCount = 0
    //     //     if (response == questionResponses[index - 1]) {
    //     //         currentAnswerCount++
    //     //     } else {
    //     //         currentAnswerCount = 0
    //     //     }
    //     //     countedQuestionResponses = [...countedQuestionResponses, String(response) + ' (' + currentAnswerCount + ')']
    //     // })
    //     // // return questionResponses.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {})
    //     return questionResponses
    // }
    // const countAlike = (questionResponse, question, questionType) => {
    //     const counts = {}
    //     let array = sortArray(questionResponse, question)
    //     if (questionType == 'single-choice' || questionType == 'slider-10') {
    //         array.forEach(function (x) {
    //             counts[x] = (counts[x] || 0) + 1
    //         })
            
    //     } else if (questionType == 'multiple-choice' || questionType == 'multiple-choice-with-maximum') {
    //         let splitArray = []
    //         array.forEach((x) => {
    //             splitArray = splitArray.concat(x.split(','))
    //         })
    //         splitArray.forEach(function (x) {
    //             // x = x.split(',')
    //             counts[x] = (counts[x] || 0) + 1
    //         })
    //     } else if (questionType == 'rank-list') {
    //         array.forEach((response) => {
    //             console.log(response)
    //             const responseLine = response.split(',')
    //             responseLine.forEach((responseItem, index) => {
    //                 // counts[responseItem] = (counts[responseItem] || 0) + 1
    //                 console.log(responseItem)
    //                 console.log(responseLine.length - index)
    //             })
    //         })
    //         console.log(counts)
    //     }
    //     const countsSorted = Object.fromEntries(
    //         Object.entries(counts).sort(([,a],[,b]) => b-a)
    //     )
    //     return countsSorted
    // }

    const handleKeydown = event => {
		if ((event.key == 'ArrowRight' || event.key == ' ' ) && currentQuestion < formData.questions.length) {
            titleScreen = false
            if (formData.questions[currentQuestion].dataVisual === 'list' && slideBuildStage == 2 && listBuildStage < (getQuestionResponse().length - 1)) {
                listBuildStage++
            } else if (slideBuildStage >= 2) { currentQuestion++; slideBuildStage = 0; listBuildStage = 0 } else { slideBuildStage++ }
		} else if (event.key == 'ArrowLeft' && currentQuestion > 0) {
			currentQuestion--
            slideBuildStage = 2
		}
	}

    const getQuestionResponse = questionNumber => {
        let questionResponse = []
        responses.forEach(response => {
            questionResponse.push(response.responses[questionNumber])
        })
        return questionResponse
    }

    const countQuestionResponse = questionNumber => {
        let questionResponse = getQuestionResponse(questionNumber)
        let count = {}
        let arrayToCount = []
        let scoresArray = {}
        // Mutliple select questions, split apart before counting
        questionResponse.forEach(response => {
            if (formData.questions[currentQuestion].type === 'multiple-choice' || formData.questions[currentQuestion].type === 'multiple-choice-with-maximum') {
                arrayToCount = [...arrayToCount, ...response.split(',')]
            } else if (formData.questions[currentQuestion].type === 'rank-list') {
                let responseArrayLength = response.split(',').length
                response.split(',').forEach((valueFromArray, index) => {
                    // scoresArray[valueFromArray] = scoresArray[valueFromArray] + (responseArrayLength - index)
                    // console.log(isNaN(scoresArray[valueFromArray] + (responseArrayLength - index)), (scoresArray[valueFromArray] + (responseArrayLength - index)))
                    // console.log(isNaN(responseArrayLength), responseArrayLength)
                    if (scoresArray[valueFromArray] !== undefined) {
                        scoresArray[valueFromArray] += (responseArrayLength - index)
                    } else {
                        scoresArray[valueFromArray] = (responseArrayLength - index)
                    }
                    count = scoresArray
                })
            } else {
                arrayToCount = questionResponse
            }
        })
        arrayToCount.forEach(x => { count[x] = (count[x] || 0) + 1})
        // Sort totals descending
        const countSorted = Object.fromEntries(
            Object.entries(count).sort(([,a],[,b]) => b-a)
        )
        return countSorted
    }

    const getPieChartPercentage = (questionNumber, positionNumber) => {
        let decimal = 0
        if (lastPieChartQuestion !== questionNumber) {lastPieChartDecimal = 0}
        lastPieChartQuestion = questionNumber

        if (Object.keys(countQuestionResponse(questionNumber)).length > positionNumber) {
            decimal = ((Object.entries(countQuestionResponse(questionNumber))[positionNumber][1] / responses.length))

            let combinedDecimal = decimal + lastPieChartDecimal
            lastPieChartDecimal = combinedDecimal

            return (combinedDecimal*100 + '%;')
        } else {
            return '0%;'
        }
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if !loading}

{#if titleScreen}
<div class="slide title">
    <h1>{formData.title}</h1>
    <p class="subtitle">{formData.description}</p>
    <div class="image" style={'background-image: url("' + formData.imageURL + '")'}/>
</div>
{:else}

{#key currentQuestion}
<div class="slide">
    <!-- TITLE -->
    {#if slideBuildStage >= 1}
    <h1 class="question-title" in:fly="{{ y: 40, duration: 500 }}" out:fade="{{ duration: 500 }}">{formData.questions[currentQuestion].question}</h1>
    {/if}
    <!-- GRAPHS & LISTS -->
    {#if slideBuildStage === 2}

        <!-- PIE CHART -->
        {#if formData.questions[currentQuestion].dataVisual === 'pie'}
            <div class="data-visual pie" in:fly="{{ y: -60, duration: 500 }}" out:fade="{{ duration: 500 }}">
                <div class="pie-chart" style={
                    "--pos1:" + getPieChartPercentage(currentQuestion, 0) +
                    "--pos2:" + getPieChartPercentage(currentQuestion, 1) +
                    "--pos3:" + getPieChartPercentage(currentQuestion, 2) +
                    "--pos4:" + getPieChartPercentage(currentQuestion, 3) +
                    "--pos5:" + getPieChartPercentage(currentQuestion, 4)
                }/>
                <div class="graph-key">
                    {#each Object.entries(countQuestionResponse(currentQuestion)) as countTotal}
                    <div class="graph-key-item">
                        <div class="count">{countTotal[1]}</div>
                        <p class="name">{countTotal[0]}</p>
                    </div>
                    {/each}
                </div>
            </div>

        <!-- BAR CHART -->
        {:else if formData.questions[currentQuestion].dataVisual === 'bar-chart'}
        <div class="data-visual bar" in:fly="{{ y: -60, duration: 500 }}" out:fade="{{ duration: 500 }}">
            <div class="bar-chart">
                {#each Array(responses.length + 1) as _, index}
                    <div class="vertical-axis-number" style={'grid-row: ' + (index + 2)}>{(responses.length - index)}</div>
                    <div class="horizontal-line" style={'grid-row: ' + (index + 2)}/>
                {/each}
                {#each Object.entries(countQuestionResponse(currentQuestion)) as countTotal, columnIndex}
                <div class="bar" style={'grid-row: ' + (responses.length + 2) + ' / ' + ((responses.length + 2) - countTotal[1]) + '; grid-column: ' + (columnIndex + 3)}>
                </div>
                <p class="bar-name" style={'grid-row: ' + (responses.length + 2 ) + '; grid-column: ' + (columnIndex + 3)}>{countTotal[0]}</p>
                {/each}
            </div>
        </div>

        <!-- HORIZONTAL BAR CHART -->
        {:else if formData.questions[currentQuestion].dataVisual === 'horizontal-bar-chart'}
        <div class="data-visual horiz-bar" in:fly="{{ y: -60, duration: 500 }}" out:fade="{{ duration: 500 }}">
            <div class="horizontal-bar-chart" style={'grid-template-columns: '}>
                {#each Array(Object.entries(countQuestionResponse(currentQuestion))[0][1]) as _, index}
                    <div class="vertical-line" style={'grid-column: ' + (index + 1) + '; grid-row: 1 / ' + (Object.entries(countQuestionResponse(currentQuestion)).length + 1)}/>
                {/each}
                {#each Object.entries(countQuestionResponse(currentQuestion)) as countTotal, columnIndex}
                <div class="bar" style={'grid-column: ' + 2 + ' / ' + (countTotal[1] + 1) + '; grid-row: ' + (columnIndex + 1)} label={countTotal[0]}>
                </div>
                <p class="bar-name" style={'grid-row: ' + (columnIndex + 1)}>{countTotal[0]}</p>
                {/each}
            </div>
        </div>

        <!-- BULLETED LIST -->
        {:else if formData.questions[currentQuestion].dataVisual === 'list'}
            <div class="data-visual list">
                <ul>
                {#each getQuestionResponse(currentQuestion) as response, index}
                    {#if listBuildStage >= index }
                    <li class="bullet-list-item" in:fly="{{ y: -60, duration: 500 }}" out:fade="{{ duration: 500 }}">{response}</li>
                    {/if}
                {/each}
                </ul>
            </div>
        {/if}


    {/if}
        <!-- {#if formData.questions[currentQuestion].type === 'short-text' || formData.questions[currentQuestion].type === 'long-text'}
        <div class="list">
            
        </div>
        {/if} -->
    <!-- {/if} -->
    <!-- {countedResponse(responses, index)} -->
    <!-- <div class="question-responses">
        {getQuestionResponse(currentQuestion)}
        {#each getQuestionResponse(currentQuestion) as response}
                <li class="in-order">{response}</li>
            {/each} -->
        
        <!-- <div class="pie-chart" style="--pos1: {(5/9)*100}%;"></div> -->
        
</div>
{/key}
{/if}
{/if}

<style>
    .question {
        margin-bottom: 60px;
    }
    .question-responses {
        margin-top: 20px;
    }
    button.form-settings {
        position: absolute;
        top: 0px;
        right: 0px;
    }
    .question li {
        background: #222;
        border-radius: 6px 6px 6px 0;
        min-width: 400px;
        width: min-content;
        padding: 8px 28px;
        margin-bottom: 8px;
    }
    .question li.in-order {
        margin-left: 50px;
        list-style: none;
    }
    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        float: left;
    }

	.question {
		display: grid;
		grid-template: 60px 1fr / 45px 1fr;
		margin: 50px 7%;
	}
	.question .question-label {
		grid-row: 1;
		grid-column: 1;
		align-self: start;
	}
	.question .h2, .question h2 {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
	}
	.question .question-type {
		grid-row: 1;
		grid-column: 2;
		align-self: end;
		margin: 0;
	}
	.question span, .question .question-responses {
		grid-row: 2;
		grid-column: 2;
	}
	.question .max-selections-input {
		grid-column: 2;
		grid-row: 3;
	}

    /* TITLE SCREEN */
    .slide.title {
        grid-template: 1fr 1fr / 1fr 1fr;
        margin: auto;
    }
    .slide.title h1 {
        grid-row: 1;
        grid-column: 1;
        align-self: end;
        margin-left: 10vw;
        font-size: 4vw;
    }
    .slide.title p.subtitle {
        grid-row: 2;
        grid-column: 1;
        align-self: start;
        opacity: 0.6;
        font-size: 1vw;
        font-weight: 400;
        margin-top: 0.5vw;
        margin-left: 10vw;
    }
    .slide.title .image {
        grid-row: 1 / 3;
        grid-column: 2;
        align-self: center;
        background-size: cover;
        height: 80%;
        width: 70%;
        background-repeat: no-repeat;
        border-radius: 1vw;
    }

    /* SLIDE */
    .slide {
        display: grid;
        grid-template: 20% 52% 28% / 1fr;
        width: 100%;
        aspect-ratio: 16 / 9;
        overflow: hidden;
    }
    .graph-key-item {
        display: grid;
        grid-template: 2.5vw / 2.5vw min-content;
        margin-bottom: 0.6vw;
    }
    .graph-key-item .count {
        width: 100%;
        height: 100%;
        aspect-ratio: 1 / 1;
        /* background: #855EFF; */
        border-radius: 3px;
        font-size: 1.8vw;
        font-weight: bold;
        align-self: center;
        text-align: center;
        padding-top: 3%;
        box-sizing: border-box;
    }
    .graph-key-item .name {
        align-self: center;
        margin-left: 1.3vw;
        font-size: 1.5vw;
        white-space: nowrap;
    }
    div.graph-key-item:nth-of-type(5n+1) .count {
        background: #855EFF;
    }
    div.graph-key-item:nth-of-type(5n+2) .count {
        background: #CE48E8;
    }
    div.graph-key-item:nth-of-type(5n+3) .count {
        background: #F18B69;
    }
    div.graph-key-item:nth-of-type(5n+4) .count {
        background: #FF5D7F;
    }
    div.graph-key-item:nth-of-type(5n+5) .count {
        background: #FFA733;
    }
    .pie-chart {
        border-radius: 50%;
        background: conic-gradient(#855EFF 0% var(--pos1), #CE48E8 var(--pos1) var(--pos2), #F18B69 var(--pos2) var(--pos3), #FF5D7F var(--pos3) var(--pos4), #FFA733 var(--pos4) var(--pos5), #855EFF var(--pos5) 100%);
        height: 100%;
        aspect-ratio: 1 / 1;
        justify-self: right;
    }
    h1.question-title {
        text-align: center;
        grid-row: 3;
        font-size: 3.4vw;
        place-self: center;
        width: 90%;
    }
    .data-visual {
        grid-row: 2;
        width: 100%;
        height: 100%;
    }
    .data-visual.pie {
        display: grid;
        grid-template: 100% / 1.3fr 1fr;
    }
    .data-visual.bar {
        /* display: grid; */
    }
    .data-visual.list {
        columns: 2;
        column-fill: auto;
        width: 80%;
        margin: auto;
    }
    /* .data-visual {
        grid-row: 2;
        place-self: center;
        display: grid;
        grid-template: 1fr / 1.5fr 1fr;
        height: 100%;
        aspect-ratio: 1.6 / 1;
    } */
    .data-visual .graph-key {
        align-self: center;
        margin-left: 4vw;
    }
    .data-visual .bullet-list-item {
        font-size: 1.8vw;
        margin-bottom: 1.5vw;
    }
    .bar-chart, .horizontal-bar-chart {
        display: grid;
        /* grid-template-rows: repeat(8, 1fr); */
        grid-template-columns: 4% 2% repeat(10, 1fr) 2%;
        grid-column-gap: 0.8vw;
        width: 70%;
        height: 100%;
        margin: auto;
    }
    .bar-chart .bar, .horizontal-bar-chart .bar {
        background: #855EFF;
        border-radius: 3px;
    }
    .bar-chart .bar-name {
        text-align: center;
        margin: 1vw 0 0 0;
        font-size: 1.2vw;
        font-weight: 400;
    }
    .bar-chart .vertical-axis-number {
        grid-column: 1;
        transform: translateY(-10px);
        opacity: 0.25;
        font-weight: bold;
        font-size: 1vw;
    }
    .bar-chart .horizontal-line {
        grid-column: 2/-1;
        z-index: -10;
        border-top: 1px solid #262626;
    }
    .horizontal-bar-chart {
        grid-template-columns: 10%;
        /* grid-template-columns: 10% repeat(70, 1fr) 2%; */
        grid-column-gap: 0;
        grid-row-gap: 0.4vw;
    }
    .horizontal-bar-chart .bar-name {
        grid-column: 1;
        margin: 3% 20% 3% 0;
        height: min-content;
        align-self: center;
        text-align: right;
        white-space: nowrap;
    }
    .horizontal-bar-chart .vertical-line {
        z-index: -10;
        border-right: 1px solid #161616;
    }
    .horizontal-bar-chart div.vertical-line:nth-last-of-type(5n+2) {
        border-right: 1px solid #262626;
    }
</style>